import type { GameState } from '../core/gameState'
import { parseGameSave, serializeGameSave } from './saveState'

export function downloadGameSave(state: GameState): void {
  const blob = new Blob([serializeGameSave(state)], {
    type: 'application/json;charset=utf-8',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = `skyward-race-turn-${state.turn}.json`
  document.body.append(link)
  link.click()
  link.remove()

  window.setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 0)
}

export async function readGameSaveFile(file: File): Promise<GameState> {
  return parseGameSave(await file.text())
}
